import React from 'react'
import { l, SectionMessage } from '@manychat/manyui'

import { TouchedContactLimits } from 'common/billing/constants/TouchedContactLimits'

export const InfoSectionText = ({ activeContacts }: { activeContacts: number }) => {
  if (activeContacts <= TouchedContactLimits.free) {
    return (
      <SectionMessage
        variant="info"
        title={l.translate('Your next move is on us. Get 3 months of Essential for free.')}
        description={l.translate(
          'Includes up to 250 Active Contacts /mo, unlimited live automations, automatic email and phone number capture, and more. Try free for 3 months, then pay $17 /mo. Limited time offer.',
        )}
      />
    )
  }
  if (activeContacts <= TouchedContactLimits.essential) {
    return (
      <SectionMessage
        variant="info"
        title={l.translate('Keep your automations running. Try Essential free for 3 months.')}
        description={l.translate(
          'Includes up to 250 Active Contacts /mo, unlimited live automations, automatic email and phone number capture, and more. Try free for 3 months, then pay $17 /mo. Limited time offer.',
        )}
      />
    )
  }
  return (
    <SectionMessage
      variant="info"
      title={l.translate('Keep your automations running. Upgrade to Pro.')}
      description={l.translate(
        'Includes up to 2500 Active Contacts /mo, unlimited live automations, connect up to 3 channels, and more.',
      )}
    />
  )
}
